var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "project-create-new-modal",
        pivotY: 0.2,
        width: "590",
        height: "auto"
      }
    },
    [
      _c("div", { staticClass: "modal-img-container" }, [
        _c("img", {
          staticClass: "modal-img",
          attrs: {
            src: _vm.urlForStatic("/img/projectPreviewsDemo/house3.jpg")
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-close-btn-point" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-btn-container",
            on: {
              click: function($event) {
                return _vm.hideModal("project-create-new-modal")
              }
            }
          },
          [_c("SVGModalClose")],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-title" }, [
        _vm._v("\n        Создать новый проект\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-text" }, [
        _vm._v(
          "\n        Назовите свой проект и добавьте одну или несколько фотографий\n    "
        )
      ]),
      _vm._v(" "),
      _c("input", {
        staticClass: "modal-text-input",
        attrs: { type: "text", placeholder: "Новый проект*" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "modal-button" }, [
        _vm._v("\n        Добавить фото\n    ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }